import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiRoutes } from '../../constants';
import { Agent } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class AgentApiService {
    http = inject(HttpClient);
    getPartnerId() {
        return this.http.get<{
            success: boolean;
            data: number;
            error?: string;
        }>(`${ApiRoutes.agent}GetPartnerId`);
    }
    getAgentDetails(agentId: number) {
        let params = new HttpParams();
        params = params.append('agentId', agentId);
        return this.http.get<{
            success: boolean;
            data: Agent;
            errors?: string[];
        }>(`${ApiRoutes.agent}GetAgentById`, { params: params });
    }
}
